import { fromJS } from 'immutable'

import { getUserAccessStatus, triggerAccessBot, checkUserExists, clearUserCheck, setUserCheckResults, clearAccessBotResults, clearUserStatus } from './actions'

let defaultState = fromJS({})

export default function AccessSelfService (state = defaultState, action) {
  state = fromJS(state) // Force immutable in case of rehydration

  switch (action.type) {
    case getUserAccessStatus.event.success:
      return state.set('accessStatus', action.payload)
    case triggerAccessBot.event.success:
      return state.set('accessBotResults', action.payload)
    case checkUserExists.event.success:
      return state.set('userCheckResults', action.payload)
    case clearUserCheck.type:
      return state.set('userCheckResults', null)
    case setUserCheckResults.type:
      return state.set('userCheckResults', action.payload)
    case clearAccessBotResults.type:
      return state.set('accessBotResults', null)
    case clearUserStatus.type:
      return state.set('accessStatus', null)
    default:
      return state
  }
}

export const selectAccessStatus = state => state.AccessSelfService.get('accessStatus')
export const selectAccessBotResults = state => state.AccessSelfService.get('accessBotResults')
export const selectUserCheckResults = state => state.AccessSelfService.get('userCheckResults')


// WEBPACK FOOTER //
// ./client/src/accessSelfService/reducer.js